export class ForgottenPassword {
  public username: string;  
  constructor() {
    this.username = '';    
  }
}

export class ForgotPasswordModel {
  EndPointURL: string;
  username: string;
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/forgottenpassword/forgottenpassword.ts